import { useNavigate } from 'react-router-dom';
import Reveal from '../Components/Reveal';
import '../styles/About.css';
import codingImg from '../Assets/Industrial facility with digital twin overlay.png';
import typingImg from '../Assets/Futuristic data analytics in action.png';
import digitalTwinSpecImg from '../Assets/digital twin.jpg';
import mobileAppImg from '../Assets/mobile app.jpg';
import aiSpecImg from '../Assets/AI.jpg';

const STEPS = [
  {
    num: '01',
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/>
      </svg>
    ),
    title: 'Understand the Environment',
    body: 'We analyze operational workflows, user needs, and technical constraints.',
  },
  {
    num: '02',
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect width="8" height="4" x="8" y="2" rx="1" ry="1"/><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/>
      </svg>
    ),
    title: 'Design Intelligent Systems',
    body: 'We architect scalable solutions combining AI, XR, and data.',
  },
  {
    num: '03',
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect width="16" height="16" x="4" y="4" rx="2"/><rect width="6" height="6" x="9" y="9" rx="1"/>
        <path d="M15 2v2M15 20v2M2 15h2M2 9h2M20 15h2M20 9h2M9 2v2M9 20v2"/>
      </svg>
    ),
    title: 'Build & Integrate',
    body: 'We develop production-ready systems integrated with existing infrastructure.',
  },
  {
    num: '04',
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"/><polyline points="16 7 22 7 22 13"/>
      </svg>
    ),
    title: 'Deploy & Optimize',
    body: 'We ensure performance, usability, and continuous improvement post-deployment.',
  },
];

const SPECIALIZATIONS = [
  { title: 'Artificial Intelligence & Machine Learning', span: 'large', img: aiSpecImg },
  { title: 'Extended Reality (AR, VR, MR)',              span: 'small', img: 'https://images.unsplash.com/photo-1617802690992-15d93263d3a9?w=800&auto=format&fit=crop' },
  { title: 'Digital Twin Platforms',                     span: 'small', img: digitalTwinSpecImg },
  { title: 'Mobile & Enterprise Applications',           span: 'small', img: mobileAppImg, alignRight: true },
  { title: 'Advanced Data Analytics',                    span: 'small', img: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&auto=format&fit=crop' },
];

const ECOSYSTEM = [
  {
    name: 'DigitalWorks',
    label: 'Platform & Technology Layer',
    body: 'The technology engine of the Teczo ecosystem. We architect the data layer, build the platform layer, and deliver application-layer solutions — spanning AI models, XR environments, digital twin platforms, and enterprise systems.',
    cta: 'Our Capabilities',
    href: '/services',
    external: false,
    img: 'https://images.unsplash.com/photo-1518770660439-4636190af475?w=1000&auto=format&fit=crop',
    badgeColor: '#29b0ceff',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"/>
        <circle cx="12" cy="12" r="3"/>
      </svg>
    ),
  },
  {
    name: 'EnergyWorks',
    label: 'Industry Application Layer',
    body: 'The industry-facing arm that deploys DigitalWorks technology directly into Energy, Oil & Gas, and heavy industrial operations — from offshore digital twins to predictive maintenance systems on live assets.',
    cta: 'Visit EnergyWorks',
    href: process.env.REACT_APP_ENERGYWORKS_URL || 'http://localhost:3001',
    external: true,
    img: 'https://images.unsplash.com/photo-1513828583688-c52646db42da?w=1000&auto=format&fit=crop',
    badgeColor: '#0f172a',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"/>
      </svg>
    ),
  },
  {
    name: 'LogisticsWorks',
    label: 'Supply Chain & Logistics Layer',
    body: 'Extending the ecosystem into global trade, warehousing, and autonomous logistics — connecting the physical movement of goods to a unified digital intelligence layer.',
    cta: 'Coming Soon',
    href: null,
    external: false,
    img: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=1000&auto=format&fit=crop',
    badgeColor: '#059669',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M5 17H3a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v3"/><rect width="13" height="13" x="9" y="11" rx="2"/>
        <path d="M5 17a2 2 0 1 0 4 0 2 2 0 0 0-4 0M15 5l-3 3 3 3"/>
      </svg>
    ),
  },
];

const About = () => {
  const navigate = useNavigate();

  return (
    <main className="dw-about">

      {/* ── HERO ───────────────────────────────────────────── */}
      <header className="dw-about__hero-wrap">
        <div className="dw-about__hero">
          <Reveal animation="fade-up">
            <div className="dw-about__hero-content">
              <span className="dw-about__hero-eyebrow">Innovation Leader</span>
              <h1 className="dw-about__hero-heading">About Us</h1>
              <p className="dw-about__hero-subtitle">Revolutionizing Industries with Immersive AI &amp; XR Solutions</p>
              <p className="dw-about__hero-sub">
                We are the technology innovation and system development subsidiary of Teczo — building intelligent systems that bridge the physical and digital world.
              </p>
            </div>
          </Reveal>
        </div>
      </header>

      {/* ── OVERVIEW / VISION / MISSION ─────────────────────── */}
      <section className="dw-about__overview">
        <div className="dw-about__overview-inner">

          <Reveal animation="fade-right">
            <div className="dw-about__overview-left">
              <h2 className="dw-about__overview-heading">Transforming the Way We Interact.</h2>
              <p className="dw-about__overview-body">
                DigitalWorks is focused on delivering advanced solutions across AI, extended reality (XR), digital twins, and data platforms. We empower organizations to transition into the digital age by transforming how they interact with data, environments, and systems.
              </p>
              <div className="dw-about__vision-card">
                <p className="dw-about__vm-label">Our Vision</p>
                <p className="dw-about__vision-text">To bridge the gap between physical and digital realities—creating intelligent, immersive systems that redefine how industries operate, learn, and collaborate.</p>
              </div>
              <div className="dw-about__mission-card">
                <p className="dw-about__vm-label dw-about__vm-label--light">Our Mission</p>
                <p className="dw-about__mission-text">To design and deliver scalable AI and XR solutions that drive efficiency, enhance decision-making, and unlock new possibilities across industries.</p>
              </div>
            </div>
          </Reveal>

          <Reveal animation="fade-left" delay={150} style={{ clipPath: 'none', overflow: 'visible' }}>
            <div className="dw-about__overview-right">
              <div className="dw-about__main-img-wrap">
                <img src={codingImg} alt="Engineer working" className="dw-about__main-img" />
              </div>
              <div className="dw-about__sub-img-wrap dw-about__floating">
                <img src={typingImg} alt="Detail view" />
              </div>
              <div className="dw-about__satisfaction-badge">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#2AAECC" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="8" r="6"/><path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11"/>
                </svg>
                <p className="dw-about__satisfaction-val">75%</p>
                <p className="dw-about__satisfaction-label">Client Satisfaction</p>
              </div>
            </div>
          </Reveal>

        </div>
      </section>

      {/* ── SPECIALIZATIONS ──────────────────────────────────── */}
      <section className="dw-about__spec">
        <div className="dw-about__spec-inner">
          <Reveal animation="fade-up">
            <div className="dw-about__spec-header">
              <h2 className="dw-about__spec-heading">What We Specialize In</h2>
              <p className="dw-about__spec-sub">Turning technical complexity into industrial competitive advantage.</p>
              <p className="dw-about__spec-body">
                DigitalWorks operates at the intersection of emerging technology and industrial application. Our capabilities span the full digital transformation stack — from AI-driven analytics and extended reality environments to real-time digital twins and enterprise platforms. Each specialization is engineered to solve real operational challenges at scale, enabling our clients to visualize, simulate, and optimize their world with precision.
              </p>
            </div>
          </Reveal>

          <div className="dw-about__spec-grid dw-about__spec-grid--animate">

            <div className="dw-about__spec-tile dw-about__spec-tile--large">
              <div className="dw-about__spec-clip">
                <img src={SPECIALIZATIONS[0].img} alt={SPECIALIZATIONS[0].title} className="dw-about__spec-img" />
                <div className="dw-about__spec-overlay">
                  <h3 className="dw-about__spec-title dw-about__spec-title--lg">
                    Artificial Intelligence &amp; Machine Learning
                  </h3>
                  <p className="dw-about__spec-desc">
                    Transforming fragmented industrial information into predictive and automated workflows that identify non-linear operational patterns.
                  </p>
                </div>
              </div>
            </div>

            <div className="dw-about__spec-tile dw-about__spec-tile--xr">
              <div className="dw-about__spec-clip">
                <img src={SPECIALIZATIONS[1].img} alt={SPECIALIZATIONS[1].title} className="dw-about__spec-img" />
                <div className="dw-about__spec-overlay dw-about__spec-overlay--blue">
                  <h3 className="dw-about__spec-title">Extended Reality (AR, VR, MR)</h3>
                  <p className="dw-about__spec-desc dw-about__spec-desc--blue">
                    Bridging the gap between abstract technical data and human intuition through immersive visualization and remote spatial collaboration.
                  </p>
                </div>
              </div>
            </div>

            <div className="dw-about__spec-tile dw-about__spec-tile--dt">
              <div className="dw-about__spec-clip">
                <img src={SPECIALIZATIONS[2].img} alt={SPECIALIZATIONS[2].title} className="dw-about__spec-img" />
                <div className="dw-about__spec-overlay dw-about__spec-overlay--slate">
                  <h3 className="dw-about__spec-title">Digital Twin Platforms</h3>
                  <p className="dw-about__spec-desc">
                    Building real-time 3D environments that replicate physical assets, allowing teams to simulate changes before they impact the physical site.
                  </p>
                </div>
              </div>
            </div>

            <div className="dw-about__spec-tile dw-about__spec-tile--mobile">
              <div className="dw-about__spec-clip">
                <img src={SPECIALIZATIONS[3].img} alt={SPECIALIZATIONS[3].title} className="dw-about__spec-img" />
                <div className="dw-about__spec-overlay dw-about__spec-overlay--purple">
                  <h3 className="dw-about__spec-title">Mobile &amp; Enterprise Apps</h3>
                  <p className="dw-about__spec-desc dw-about__spec-desc--purple">
                    Developing seamless digital experiences that combine performance, high-stakes usability, and enterprise-grade industrial scalability.
                  </p>
                </div>
              </div>
            </div>

            <div className="dw-about__spec-tile dw-about__spec-tile--analytics">
              <div className="dw-about__spec-clip">
                <img src={SPECIALIZATIONS[4].img} alt={SPECIALIZATIONS[4].title} className="dw-about__spec-img" />
                <div className="dw-about__spec-overlay dw-about__spec-overlay--cyan">
                  <h3 className="dw-about__spec-title">Advanced Data Analytics</h3>
                  <p className="dw-about__spec-desc dw-about__spec-desc--cyan">
                    Engineering the data foundations that fuel intelligence, ensuring integrity across complex distributed networks and edge systems.
                  </p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ── APPROACH / ROADMAP ───────────────────────────────── */}
      <section className="dw-about__approach">
        <div className="dw-about__approach-inner">

          <Reveal animation="fade-right">
            <div className="dw-about__approach-left">
              <span className="dw-about__approach-badge">Our Methodology</span>
              <h2 className="dw-about__approach-heading">The Roadmap to Intelligence</h2>
              <p className="dw-about__approach-body">We bridge the gap between legacy infrastructure and digital intelligence with a systematic methodology.</p>
            </div>
          </Reveal>

          <div className="dw-about__steps">
            {STEPS.map((s, i) => (
              <Reveal key={s.num} animation="fade-up" delay={i * 80} style={{ clipPath: 'none', overflow: 'visible' }}>
                <div className="dw-about__step-card">
                  <span className="dw-about__step-num-bg">{s.num}</span>
                  <div className="dw-about__step-icon">{s.icon}</div>
                  <h4 className="dw-about__step-title">{s.title}</h4>
                  <p className="dw-about__step-body">{s.body}</p>
                </div>
              </Reveal>
            ))}
          </div>

        </div>
      </section>

      {/* ── TECZO ECOSYSTEM ──────────────────────────────────── */}
      <section className="dw-about__ecosystem">
        <div className="dw-about__ecosystem-inner">
          <Reveal animation="fade-up">
            <div className="dw-about__ecosystem-header">
              <h2 className="dw-about__ecosystem-heading">The Teczo Ecosystem</h2>
              <p className="dw-about__ecosystem-sub">Synergistic expertise driving end-to-end industrial transformation.</p>
            </div>
          </Reveal>
          <div className="dw-about__ecosystem-grid">
            {ECOSYSTEM.map((item, i) => (
              <Reveal key={item.name} animation="fade-up" delay={i * 120} style={{ overflow: 'visible', clipPath: 'none' }}>
                <div className="dw-about__eco-card">
                  <div className="dw-about__eco-clip">
                    <img src={item.img} alt={item.name} className="dw-about__eco-bg-img" />
                    <div className="dw-about__eco-content">
                      {/* Title block — badge + name/label inline, pinned to bottom */}
                      <div className="dw-about__eco-title-block">
                        <div className="dw-about__eco-badge" style={{ background: item.badgeColor }}>
                          {item.icon}
                        </div>
                        <div className="dw-about__eco-title-text">
                          <h3 className="dw-about__eco-name">{item.name}</h3>
                          <p className="dw-about__eco-label">{item.label}</p>
                        </div>
                      </div>
                      {/* Expandable block — slides in on hover */}
                      <div className="dw-about__eco-expand">
                        <p className="dw-about__eco-body">{item.body}</p>
                        {item.href ? (
                          item.external ? (
                            <a href={item.href} target="_blank" rel="noopener noreferrer" className="dw-about__eco-cta">
                              {item.cta}
                              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M5 12h14M12 5l7 7-7 7"/>
                              </svg>
                            </a>
                          ) : (
                            <button className="dw-about__eco-cta" onClick={() => navigate(item.href)}>
                              {item.cta}
                              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M5 12h14M12 5l7 7-7 7"/>
                              </svg>
                            </button>
                          )
                        ) : (
                          <div className="dw-about__eco-cta dw-about__eco-cta--disabled">
                            {item.cta}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* ── FOOTER CTA ───────────────────────────────────────── */}
      <div className="dw-about__footer-wrap">
        <div className="dw-about__footer-cta">
          <Reveal animation="fade-up">
            <div className="dw-about__footer-inner">
              <h2 className="dw-about__footer-heading">Join the Innovation.</h2>
              <p className="dw-about__footer-sub">Ready to transform your organizational systems with immersive intelligence?</p>
              <button className="dw-about__footer-btn-primary" onClick={() => navigate('/contact')}>Contact Our Team</button>
            </div>
          </Reveal>
        </div>
      </div>

    </main>
  );
};

export default About;
